import lscache from 'lscache'

const DEFAULT_TTL_MINUTES = 60 * 24

export function pickStickyVariant({ variants, cacheKey, ttlMinutes = DEFAULT_TTL_MINUTES }) {
	if (!Array.isArray(variants) || variants.length === 0) {
		return null
	}

	const cachedId = lscache.get(cacheKey)
	const cached = variants.find((variant) => variant.id === cachedId)

	if (cached) {
		return cached
	}

	const picked = variants[Math.floor(Math.random() * variants.length)]
	lscache.set(cacheKey, picked.id, ttlMinutes)

	return picked
}
